import { useState, useEffect, memo } from 'react';
import { useAuth } from "../../context/loginContext.js";

const RoTbGes = (params) => {

    const { user } = useAuth();

    const set_data_modal = (type, data) => {

        if (type === "user") {
            document.getElementById("tipo_l").innerHTML = "Usuario";
            document.getElementById("nombre_titulo_l").innerHTML = "<b class='text-body-tertiary'>" + data.nombre + "</b>";
            params.set_registroS(data.uuid, "user");
        }
        if (type === "rol") {
            document.getElementById("tipo_l").innerHTML = "Rol";
            document.getElementById("nombre_titulo_l").innerHTML = "<b class='text-body-tertiary'>" + data.titulo + "</b>";
            params.set_registroS(data.uuid, "rol");
        }
        if (type === "tablero") {
            document.getElementById("tipo_l").innerHTML = "Tablero";
            document.getElementById("nombre_titulo_l").innerHTML = "<b class='text-body-tertiary'>" + data.titulo + "</b>";
            params.set_registroS(data.uuid, "tablero");
        }
        if (type === "guser") {
            document.getElementById("tipo_l").innerHTML = "Grupo usuario";
            document.getElementById("nombre_titulo_l").innerHTML = "<b class='text-body-tertiary'>" + data.titulo + "</b>";
            params.set_registroS(data.uuid, "guser");
        }
        if (type === "gtablero") {
            document.getElementById("tipo_l").innerHTML = "Gurpo tablero";
            document.getElementById("nombre_titulo_l").innerHTML = "<b class='text-body-tertiary'>" + data.titulo + "</b>";
            params.set_registroS(data.uuid, "gtablero");

        }
    }

    const set_data_modal_update = (type) => {
        console.log(params.datos)
        if (type === "user") {
            document.getElementById("nameUp").value = params.datos.nombre;
            document.getElementById("correoUp").value = params.datos.correo;
            document.getElementById("MU-Ca-2").value = params.datos.uuid_rol;
            document.getElementById("fSCheckCheckedEs").checked = params.datos.estatus === 1 ? true : false;
            document.getElementById("fSCheckCheckedEsLab").innerHTML = params.datos.estatus === 1 ? "On" : "Off";
            params.set_registroPaS(params.datos.secret);
            params.set_registroS(params.datos.uuid, "user");
            document.getElementById("r-gt-u-up-replt").click();
            //params.get_gtableros_user(params.datos.uuid);
        }

        if (type === "rol") {
            document.getElementById("CargoUp").value = params.datos.titulo;
            params.set_registroS(params.datos.uuid, "rol");
        }

        if (type === "tablero") {
            document.getElementById("TituloUp").value = params.datos.titulo;
            document.getElementById("UrlUp").value = params.datos.url;
            document.getElementById("Notaup").value = params.datos.nota;
            document.getElementById("fSCheckCheckedEstable").checked = params.datos.estatus === 1 ? true : false;
            document.getElementById("fSCheckCheckedEsLabEstable").innerHTML = params.datos.estatus === 1 ? "On" : "Off";
            params.set_registroS(params.datos.uuid, "tablero");
            //console.log(params.datos.uuid)

            //params.get_gtableros_tablero(params.datos.uuid);
            document.getElementById("r-gt-t-up-replt").click();
        }

        if (type === "gtablero") {
            document.getElementById("TitulogtUp").value = params.datos.titulo;
            document.getElementById("NotagtUp").value = params.datos.nota;
            document.getElementById("fSCheckCheckedEsgtablero").checked = params.datos.estatus === 1 ? true : false;
            document.getElementById("fSCheckCheckedEsLabEsgtablero").innerHTML = params.datos.estatus === 1 ? "On" : "Off";
            params.set_registroS(params.datos.uuid, "gtablero");
        }

    }


    if (params.type === "usuarios") {

        var grupos_obj = [];
        if (params.datos.Gtableros !== null) {
            var split_grupos = (params.datos.Gtableros).split("|xxx|");
            for (let i_sg = 0; i_sg < split_grupos.length; i_sg++) {
                const element = split_grupos[i_sg];
                //console.log(i_sg % 3)
                if (((i_sg + 1) % 3) === 0) {
                    grupos_obj.push(<div key={"label-gt-u-" + i_sg}><button className='btn btn-outline-secondary-2'><i className="bi bi-columns-gap"></i> {element}</button><br></br></div>)
                } else {
                    grupos_obj.push(<button key={"label-gt-u-" + i_sg} className='btn btn-outline-secondary-2'><i className="bi bi-columns-gap"></i> {element}</button>)
                }

            }

        }
        return (
            <tr>
                <td scope="col">{params.datos.correo}</td>
                <td scope="col">{params.datos.estatus === 1 ? <i className="bi bi-circle-fill text-success"></i> : <i className="bi bi-circle-fill text-danger"></i>}</td>
                <td scope="col">{params.datos.nombre}</td>
                <td scope="col">{params.datos.rol_titulo}</td>
                <td scope="col">{grupos_obj.length !== 0 ? grupos_obj : "---"}</td>
                <td scope="col">
                    <button className='btn btn-info color_02_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_usuariosUpd" aria-label="Close" onClick={() => { set_data_modal_update("user") }}><i className="bi bi-pencil-square"></i></button>
                    <button className='btn btn-dark color_01_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_deleteE" aria-label="Close" onClick={() => { set_data_modal("user", params.datos) }}><i className="bi bi-trash3-fill"></i></button>
                </td>
            </tr>
        );
    }

    if (params.type === "roles") {
        return (
            <tr>
                <td scope="col">{params.datos.titulo}</td>
                {
                    params.datos !== null ?
                        params.datos.titulo !== "Administrador" ?
                            <td scope="col">
                                <button className='btn btn-info color_02_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_rolesUpd" aria-label="Close" onClick={() => { set_data_modal_update("rol") }}><i className="bi bi-pencil-square"></i></button>
                                <button className='btn btn-dark color_01_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_deleteE" aria-label="Close" onClick={() => { set_data_modal("rol", params.datos) }}><i className="bi bi-trash3-fill"></i></button>
                            </td>
                            :
                            <td scope="col">

                            </td>
                        :
                        <td scope="col">
                            <button className='btn btn-info color_02_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_rolesUpd" aria-label="Close" onClick={() => { set_data_modal_update("rol") }}><i className="bi bi-pencil-square"></i></button>
                            <button className='btn btn-dark color_01_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_deleteE" aria-label="Close" onClick={() => { set_data_modal("rol", params.datos) }}><i className="bi bi-trash3-fill"></i></button>
                        </td>
                }

            </tr>
        );
    }

    if (params.type === "tableros") {
        var grupos_obj = [];
        if (params.datos.Gtableros !== null) {
            var split_grupos = (params.datos.Gtableros).split("|xxx|");
            for (let i_sg = 0; i_sg < split_grupos.length; i_sg++) {
                const element = split_grupos[i_sg];
                //console.log(i_sg % 3)
                if (((i_sg + 1) % 3) === 0) {
                    grupos_obj.push(<div key={"label-gt-t-" + i_sg}><button className='btn btn-outline-secondary-2'><i className="bi bi-columns-gap"></i> {element}</button><br></br></div>)
                } else {
                    grupos_obj.push(<button key={"label-gt-t-" + i_sg} className='btn btn-outline-secondary-2'><i className="bi bi-columns-gap"></i> {element}</button>)
                }

            }

        }
        return (
            <tr>
                <td scope="col">{params.datos.titulo}</td>
                <td scope="col">{params.datos.estatus === 1 ? <i className="bi bi-circle-fill text-success"></i> : <i className="bi bi-circle-fill text-danger"></i>}</td>
                <td scope="col">{grupos_obj.length !== 0 ? grupos_obj : "---"}</td>
                <td scope="col">
                    <div style={{ maxHeight: "100vh", maxWidth: "300px", overflowX: "auto" }}>
                        {params.datos.url}
                    </div>
                </td>
                <td scope="col">{params.datos.nota}</td>
                <td scope="col">
                    <button className='btn btn-info color_02_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_tableroUpd" aria-label="Close" onClick={() => { set_data_modal_update("tablero") }}><i className="bi bi-pencil-square"></i></button>
                    <button className='btn btn-dark color_01_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_deleteE" aria-label="Close" onClick={() => { set_data_modal("tablero", params.datos) }}><i className="bi bi-trash3-fill"></i></button>
                </td>
            </tr>
        );
    }

    if (params.type === "Gtableros") {
        return (
            <tr>
                <td scope="col">{params.datos.titulo}</td>
                <td scope="col">{params.datos.estatus === 1 ? <i className="bi bi-circle-fill text-success"></i> : <i className="bi bi-circle-fill text-danger"></i>}</td>
                <td scope="col">{params.datos.nota}</td>
                <td scope="col">
                    <button className='btn btn-info color_02_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_GTablerosUpd" aria-label="Close" onClick={() => { set_data_modal_update("gtablero") }}><i className="bi bi-pencil-square"></i></button>
                    <button className='btn btn-dark color_01_bt btn-sm me-2 mt-1' data-bs-toggle="modal" data-bs-target="#m_deleteE" aria-label="Close" onClick={() => { set_data_modal("gtablero", params.datos) }}><i className="bi bi-trash3-fill"></i></button>
                </td>
            </tr>
        );
    }
}

export default memo(RoTbGes);

